import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { DeliveryProvider } from "@/contexts/delivery.context";
import { AuthProvider } from "@/contexts/auth.context";
import { Navigator } from "@/components/navigator";
import { TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from "@/config/base";
import { ProductTour } from "@/components/tour/product-tour";
import { OnboardJSTourAdapter } from "@/components/tour/adapters/onboardjs";
import { TOUR_STEPS } from "@/config/tour-steps";

export const Route = createFileRoute("/app")({
  beforeLoad: () => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    const userStr = localStorage.getItem(USER_STORAGE_KEY);

    if (!token || !userStr) {
      throw redirect({
        to: "/auth/identify",
      });
    }

    try {
      const user = JSON.parse(userStr);
      if (!user.telefoneVerificado) {
        throw redirect({
          to: "/auth/verify-phone",
          search: { telefone: user.telefone },
        });
      }
    } catch (error) {
      if (error instanceof redirect) {
        throw error;
      }
      throw redirect({
        to: "/auth/identify",
      });
    }
  },
  component: RootLayout,
});

function RootLayout() {
  return (
    <DeliveryProvider>
      <AuthProvider>
        <OnboardJSTourAdapter steps={TOUR_STEPS}>
          <section>
            <Outlet />
          </section>
          <Navigator />
          <ProductTour />
        </OnboardJSTourAdapter>
      </AuthProvider>
    </DeliveryProvider>
  );
}
